import { Club } from './../clubs/club.model';
import { BaseModel } from 'src/app/shared/models/base.model';

export class Member extends BaseModel{
    club: Club;
    clubs_id: number;
    photo:string;
    name:any
    email:any
    member_number:any
    member_type:any
    phone:any
    city:any
    address:any
    quote:any
    document:any
    document_number:any
    status_user:any
    created_at:any

 static fromJsonToObject(jsonData:any):Member{
        return Object.assign(new Member(),jsonData);
    }
}